<template>
  <div>
    <div class="zn-template-head">
      <span class="zn-template-title">市场薪酬</span>
      <span class="zn-text-grey">选择一个行业和职能会出对应的市场薪酬</span>
    </div>
    <div class="zn-template-content" ref="tplContent">
      <el-form :inline="true" size="mini" :model="formData" style="margin-top:5px">
        <el-form-item label="行业：" required>
          <el-select v-model="formData.行业" filterable @change="loadCate">
            <el-option v-for="(opt, k) in hangyeOptions" :key="k" :label="opt" :value="opt"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职能模块：" required>
          <el-select v-model="formData.职能模块" filterable @change="loadSalary" :disabled="!this.formData.行业">
            <el-option v-for="(opt, k) in cateOptions" :key="k" :label="opt" :value="opt"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div v-if="ready">
        <CategoryMoney ref="CategoryMoney" :radish="{行业: formData.行业, 职能模块: formData.职能模块, 细分职能: formData.细分职能}"></CategoryMoney>
        <div style="color:#666;margin:20px 0 5px 0;font-size:14px">同职能模块人选薪酬：</div>
        <RadishesMoney ref="RadishesMoney2" :category="formData.职能模块" :hangye="formData.行业" :xi="formData.细分职能"></RadishesMoney>
      </div>
    </div>
  </div>
</template>
<script>
import RadishesMoney from '../../../radish/src/components/radishes-money'
import CategoryMoney from '../../../radish/src/components/category-money'
export default {
  components: {RadishesMoney, CategoryMoney},
  data() {
    return {
      hangyeOptions: ['证券', '公募基金', 'PE', '医药'],
      cateOptions: [],
      xiOptions: [],
      formData: {},
    }
  },
  watch: {
    item: function() {
      this.init()
    }
  },
  mounted() {
    this.init()
    this.cateOptions = (app.categories || []).map(val => val.名称)
  },
  computed: {
    ready() {
      if (this.formData.行业 && this.formData.职能模块) return true
      return false
    }
  },
  methods: {
    init() {
      this.formData = {}
    },
    async loadCate() {
      if (this.formData.行业 && app.service('radish').getHangyeSalaryCatesByIndustry) {
        const res = await app.service('radish').getHangyeSalaryCatesByIndustry({行业:this.formData.行业})
        if (res.status == 'success') {
          this.cateOptions = res.data.职能模块.filter(c=>c.indexOf(';') == -1 && c.indexOf(',') == -1)
          this.xiOptions = res.data.细分职能
        } else {
          this.cateOptions = []
          this.xiOptions = []
        }
        delete this.formData.职能模块
        delete this.formData.细分职能
      }
    },
    loadSalary() {
      if (this.formData.行业 && this.formData.职能模块) {
        this.$nextTick(()=>{
          this.$refs.CategoryMoney && this.$refs.CategoryMoney.loadSalary()
          this.$refs.RadishesMoney2 && this.$refs.RadishesMoney2.loadData()
        })
      }
    },
  }
}
</script>
